import { BaseBus } from "./BaseBus";
import { GItem } from "./GItem";
import { PersonSel } from "./PersonSelBus";
import { SItem } from "./SItem";

export class CycleCount {
    warehouse: string;
    cycleClass: string;
    subcatagory: string;
    assigned: string;
}

export class CycleCountdetails {
    cycleCountsId?: string;
    inventoryLocationId: string;
    cycleCountClassId: string;
    inventorySubCategoryId: string;
    status?: string;
    insertUserId?: string;
    insertDt?: Date;
    updateUserId?: string;
    updateDt?: Date;
    inventoryLocationName?: string;
    cycleCountClassName?: string;
    inventorySubCategoryName?: string;
    assign?: Assign[];
    insertUserName?: string;
    assignedPersons?: any;
    uniqueCount: number;
    statusChangeDate: Date;
    createDate: Date;
}

export class Assign {
    id?: string;
    name?: string;
}

export class cycleCountDataReference {
    cycleCountClasses: GItem[];
    inventoryLocations: GItem[]
    inventorySubCategories: GItem[];
    personsSel: PersonSel[];
    adjustedReasons: GItem[];
    companyBranches: SItem[];
}

export class CycleCountInventoryInput {
    InventoryLocationId: string;
    CycleCountClassId: string;
    InventorySubCategoryId: string;
    CycleCountsId: string;
    ShowInactiveRetired: boolean;
}

export class CycleCountInventory extends BaseBus {
    inventoryId: any;
    number: string;
    inventoryDesc: string;
    avgCost: number;
    partNumber: string;
    fullDescription: string;
    quantity: number;
    qtyCounted: number;
    qtyInput: number;
    qtyDiff: number;
    inputFrom: number; //1=FjxOnline
    cycleCountAdjustedReasonId: any;
    adjustedReasonDescription: string;
    adjustedReason: string;
    costDiff: number;
    pctDiff: number;
    inventoryLocationId: any;
    inventoryLocationXrefid: any;
    aisle: string; 
    bin: string;
    section: string;
    lastDateCounted: Date;
    className: string;
    cycleCountClassId: any;
    cycleCountsId: any;
    summary: string;
    nonPart: boolean;
//    inventoryLocationName: string;
    history: History[];    
    editable: boolean;
    varianceNote: string;
    nonPartText(): any {
        if (this.nonPart) {
            return "Yes"
        }
            return "No"
    } 
}

export class History {
    tech: string;
    counted: number;
    adjustedQty: number;
    cycleCountAdjustedReasonId: any;
    adjustedReason: string;
    dateCounted: Date;
}
